function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.5482 0.00727081C107.931 0.00727081 115.536 7.61315 115.536 16.9955L115.536 90.0611L25.4826 90.0611L25.4826 16.9955C25.4826 7.61317 33.0885 0.00727081 42.4708 0.00727081L98.5482 0.00727081Z",
  fill: "#5A3CB4"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4361 106.14C15.4361 111.362 19.6706 121.624 24.8961 121.624H116.138C121.359 121.624 125.593 111.362 125.593 106.14V94.6917C125.593 92.1331 123.52 90.0601 120.962 90.0601H20.067C17.5089 90.0601 15.4361 92.1331 15.4361 94.6917L15.4361 106.14Z",
  fill: "#5A3CB4"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.1567 115.027C57.7095 120.507 79.6186 122.151 103.171 118.863C110.742 117.443 119.127 116.428 124.801 110.881C123.347 115.941 120.01 121.624 116.126 121.624H24.895C19.6701 121.624 15.4361 111.36 15.4361 106.138V99.5122C15.4361 98.7099 15.5463 97.9363 15.7343 97.1923C18.4393 105.599 24.8969 112.711 34.1567 115.027Z",
  fill: "#5A3CB4"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.1 90.0601C25.1 96.0778 45.4288 100.95 70.5126 100.95C95.5908 100.95 115.925 96.0778 115.925 90.0601H25.1Z",
  fill: "#392A58"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.2936 57.3866C20.922 57.3866 25.4847 61.9493 25.4847 67.5776V72.2871H0.142443V67.5777C0.142443 61.9493 4.70518 57.3866 10.3336 57.3866H15.2936Z",
  fill: "#5A3CB4"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.147146 82.4252V72.2838H25.4894V82.4252H0.147146Z",
  fill: "black"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M130.136 57.2085C135.765 57.2085 140.328 61.7712 140.328 67.3995V72.1227H114.999V67.3996C114.999 61.7712 119.562 57.2085 125.19 57.2085H130.136Z",
  fill: "#5A3CB4"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.005 82.2566V72.1152H140.333V82.2566H115.005Z",
  fill: "black"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.2144 133.349H108.41C111.499 133.349 114.162 131.181 114.786 128.158L116.136 121.624H25.4887L26.8381 128.158C27.4623 131.181 30.1258 133.349 33.2144 133.349Z",
  fill: "#2E293A"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M108.607 133.346V161.278H88.0312V133.346H108.607Z",
  fill: "black"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M81.6676 170.001H114.968L110.416 161.277H86.2195L81.6676 170.001Z",
  fill: "black"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.0683 133.346V161.278H33.4927V133.346H54.0683Z",
  fill: "black"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.1319 170.001H60.4325L55.8806 161.277H31.6838L27.1319 170.001Z",
  fill: "black"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.8696 22.4845V27.2112L40.9975 27.2112V22.4845L98.8696 22.4845Z",
  fill: "#392A58"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.8696 38.2396V42.9664L40.9975 42.9664V38.2396L98.8696 38.2396Z",
  fill: "#392A58"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.8696 53.9939V58.7206L40.9975 58.7206V53.9939L98.8696 53.9939Z",
  fill: "#392A58"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M345.058 90.0611L255.004 90.0611V23.2795C255.004 10.4266 265.424 0.0072937 278.277 0.0072937L321.786 0.0072937C334.639 0.0072937 345.058 10.4266 345.058 23.2795L345.058 90.0611Z",
  fill: "#5A3CB4"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M244.948 106.14C244.948 111.362 249.182 121.624 254.408 121.624H345.649C350.868 121.624 355.103 111.362 355.103 106.14V94.6917C355.103 92.1331 353.03 90.0601 350.472 90.0601H249.578C247.02 90.0601 244.948 92.1331 244.948 94.6917L244.948 106.14Z",
  fill: "#5A3CB4"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M254.625 90.0601C254.625 96.0778 274.951 100.95 300.031 100.95C325.105 100.95 345.437 96.0778 345.437 90.0601H254.625Z",
  fill: "#392A58"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M244.816 57.3866C250.445 57.3866 255.007 61.9493 255.007 67.5776V72.2871H229.665V67.5777C229.665 61.9493 234.228 57.3866 239.856 57.3866H244.816Z",
  fill: "#5A3CB4"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M229.66 82.4252V72.2838H255.002V82.4252H229.66Z",
  fill: "black"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M359.659 57.2094C365.288 57.2094 369.85 61.7721 369.85 67.4005V72.1237H344.522V67.4006C344.522 61.7722 349.084 57.2094 354.713 57.2094H359.659Z",
  fill: "#5A3CB4"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M344.517 82.2566V72.1152H369.845V82.2566H344.517Z",
  fill: "black"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M262.728 133.349H337.923C341.012 133.349 343.676 131.181 344.3 128.158L345.649 121.624H255.002L256.352 128.158C256.976 131.181 259.639 133.349 262.728 133.349Z",
  fill: "#2E293A"
});
var _ref26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M338.13 133.346V161.278H317.554V133.346H338.13Z",
  fill: "black"
});
var _ref27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M311.18 170.001H344.494L339.941 161.277H315.734L311.18 170.001Z",
  fill: "black"
});
var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M283.591 133.346V161.278H263.016V133.346H283.591Z",
  fill: "black"
});
var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.644 170.001H289.959L285.405 161.277H261.198L256.644 170.001Z",
  fill: "black"
});
var _ref30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M328.379 22.4845V27.2112L270.52 27.2112V22.4845L328.379 22.4845Z",
  fill: "#392A58"
});
var _ref31 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M328.379 38.2396V42.9664L270.52 42.9664V38.2396L328.379 38.2396Z",
  fill: "#392A58"
});
var _ref32 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M328.379 53.9939V58.7206L270.52 58.7206V53.9939L328.379 53.9939Z",
  fill: "#392A58"
});
var _ref33 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M213.281 0.00727081C222.663 0.00727081 230.269 7.61315 230.269 16.9955V90.0611L140.215 90.0611V16.9955C140.215 7.61317 147.821 0.00727081 157.204 0.00727081L213.281 0.00727081Z",
  fill: "#5A3CB4"
});
var _ref34 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M130.17 106.14C130.17 111.362 134.404 121.624 139.631 121.624H230.872C236.093 121.624 240.327 111.362 240.327 106.14V94.6917C240.327 92.1331 238.253 90.0601 235.696 90.0601H134.801C132.244 90.0601 130.17 92.1331 130.17 94.6917V106.14Z",
  fill: "#5A3CB4"
});
var _ref35 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.834 90.0601C139.834 96.0778 160.163 100.95 185.246 100.95C210.325 100.95 230.659 96.0778 230.659 90.0601H139.834Z",
  fill: "#392A58"
});
var _ref36 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M147.949 133.349H223.145C226.233 133.349 228.897 131.181 229.521 128.158L230.87 121.624H140.223L141.574 128.158C142.198 131.181 144.861 133.349 147.949 133.349Z",
  fill: "#2E293A"
});
var _ref37 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M223.341 133.346V161.278H202.765V133.346H223.341Z",
  fill: "black"
});
var _ref38 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M196.403 170.001H229.703L225.151 161.277H200.954L196.403 170.001Z",
  fill: "black"
});
var _ref39 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M168.802 133.346V161.278H148.227V133.346H168.802Z",
  fill: "black"
});
var _ref40 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M141.867 170.001H175.168L170.616 161.277H146.419L141.867 170.001Z",
  fill: "black"
});
var _ref41 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M213.603 22.4845V27.2112L155.731 27.2112V22.4845L213.603 22.4845Z",
  fill: "#392A58"
});
var _ref42 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M213.603 38.2396V42.9664L155.731 42.9664V38.2396L213.603 38.2396Z",
  fill: "#392A58"
});
var _ref43 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M213.603 53.9939V58.7206L155.731 58.7206V53.9939L213.603 53.9939Z",
  fill: "#392A58"
});
var _ref44 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.35,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.554 51.8557C185.561 51.9039 185.566 51.952 185.573 52.0002H185.533C185.541 51.952 185.548 51.9039 185.554 51.8557ZM206.542 52.0005H203.542C203.496 51.8995 203.441 51.8033 203.375 51.7152C203.144 51.4106 202.801 51.1846 202.648 50.8345C202.401 50.2751 202.683 49.5018 202.232 49.0888C201.838 48.7285 201.222 48.9415 200.703 49.0582C200.037 49.2073 199.327 49.1554 198.691 48.911C198.21 48.7267 197.624 48.4497 197.233 48.785C196.857 49.1092 197.022 49.6898 196.972 50.1983C196.355 49.8278 195.98 49.1619 195.447 48.6767C195.255 48.5025 195.009 48.3423 194.753 48.3905C194.619 48.4164 194.503 48.4961 194.388 48.5692C193.831 48.9267 193.203 49.1666 192.554 49.2953C192.454 48.8638 192.444 48.3914 192.154 48.0664C191.673 47.5301 190.808 47.7589 190.092 47.6774C189.596 47.6199 189.136 47.394 188.678 47.1939C188.219 46.9948 187.731 46.8142 187.233 46.8559C186.735 46.8985 186.227 47.2236 186.129 47.7144C186.083 47.945 186.129 48.1895 186.065 48.4164C185.988 48.6905 185.769 48.8906 185.569 49.0971C185.404 49.0656 185.239 49.0332 185.086 48.9758C184.735 48.8452 184.446 48.5915 184.132 48.3877C183.817 48.1849 183.435 48.0274 183.072 48.1228C182.515 48.271 182.234 48.948 181.685 49.1239C180.973 49.3518 180.015 48.6331 179.519 49.4555C179.427 49.6083 179.385 49.8019 179.377 50.0066C179.306 49.9612 179.237 49.9158 179.167 49.8723C178.954 49.7398 178.714 49.6148 178.465 49.6463C178.267 49.6722 178.097 49.7945 177.927 49.901C177.389 50.2399 176.774 50.4557 176.143 50.5289C175.886 50.5586 175.616 50.5752 175.373 50.6539C175.209 50.4048 174.99 50.1964 174.71 50.0797C174.281 49.901 173.798 49.9102 173.356 49.7667C172.866 49.6065 172.458 49.2675 172.008 49.0147C171.558 48.7619 171.002 48.5961 170.533 48.8109C170.076 49.0202 169.842 49.5194 169.552 49.9297C169.276 50.3177 168.922 50.6511 168.517 50.9012C168.13 51.1401 167.674 51.3272 167.447 51.7218C167.395 51.8125 167.363 51.9061 167.342 52.0005H166.623C166 52.0005 165.494 52.5052 165.494 53.1285V54.0602C165.494 54.6845 166.001 55.191 166.625 55.191H167.401L173.902 93.5633V96.7547H199.263V93.5633L205.764 55.191H206.539C207.164 55.191 207.67 54.6845 207.67 54.0602V53.1285C207.67 52.5052 207.165 52.0005 206.542 52.0005H206.542Z",
  fill: "#1A1A1A"
});
var _ref45 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M181.631 50.3173C181.541 50.2338 181.45 50.1476 181.4 50.0373C181.265 49.7462 181.446 49.4078 181.662 49.1714C181.877 48.935 182.145 48.7199 182.232 48.4121C182.296 48.185 182.25 47.9402 182.296 47.7094C182.394 47.2181 182.9 46.8927 183.398 46.85C183.898 46.8083 184.385 46.9891 184.844 47.1884C185.302 47.3886 185.76 47.6148 186.257 47.6723C186.973 47.7539 187.837 47.5249 188.318 48.0617C188.731 48.5234 188.572 49.2854 188.918 49.7999C189.061 50.0113 189.291 50.1903 189.307 50.4443C189.316 50.5778 189.261 50.7085 189.19 50.8216C188.791 51.4539 187.954 51.6207 187.209 51.6699C186.81 51.6968 186.393 51.7107 186.042 51.9035C185.879 51.9934 185.733 52.1204 185.556 52.177C185.287 52.2623 184.998 52.1733 184.731 52.0843C183.464 51.6634 182.64 51.2258 181.631 50.3173L181.631 50.3173Z",
  fill: "#F9E8C0"
});
var _ref46 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M187.418 50.4226C187.268 50.6729 186.987 50.8148 186.706 50.8944C186.426 50.9733 186.132 51.0038 185.857 51.0994C185.54 51.2078 185.233 51.4044 184.9 51.3664C184.626 51.3357 184.398 51.1522 184.172 50.9927C183.729 50.6794 183.236 50.4365 182.717 50.2753C182.62 50.2446 182.514 50.2122 182.453 50.1297C182.411 50.0722 182.398 49.999 182.386 49.9277C182.357 49.7468 182.335 49.5651 182.32 49.3825C182.311 49.2787 182.304 49.172 182.335 49.0719C182.406 48.8412 182.654 48.7113 182.89 48.6622C183.587 48.5176 184.299 48.855 185.008 48.8077C185.422 48.7799 185.855 48.6261 186.233 48.7938C186.715 49.0089 187.78 49.8219 187.418 50.4227L187.418 50.4226Z",
  fill: "#FBB03B"
});
var _ref47 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M192.566 51.2821C192.751 51.0074 192.996 50.7622 193.09 50.4458C193.255 49.8917 192.957 49.1665 193.396 48.79C193.786 48.4551 194.372 48.7317 194.853 48.9167C195.49 49.16 196.2 49.2118 196.865 49.0629C197.386 48.9463 198.002 48.7336 198.395 49.0934C198.847 49.506 198.565 50.2784 198.811 50.8372C198.965 51.1868 199.308 51.4125 199.539 51.7169C199.818 52.0878 199.922 52.5846 199.815 53.036C199.76 53.2627 199.645 53.4884 199.445 53.6077C199.282 53.7049 199.086 53.7197 198.897 53.7382C197.672 53.8529 195.877 54.8899 194.798 54.0444C194.33 53.6772 193.982 53.2396 193.462 52.9259C192.794 52.5254 191.967 52.1748 192.566 51.2822L192.566 51.2821Z",
  fill: "#F9E8C0"
});
var _ref48 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M194.616 52.4114C194.943 52.6348 195.213 52.9314 195.523 53.1763C195.834 53.421 196.212 53.6194 196.606 53.5907C197.221 53.5452 197.733 52.9657 198.346 53.0316C198.53 53.052 198.781 53.0947 198.842 52.9204C198.86 52.8684 198.851 52.8119 198.843 52.7581C198.791 52.4243 198.73 52.0711 198.511 51.8143C198.425 51.7133 198.317 51.6298 198.248 51.5177C198.131 51.3322 198.135 51.0976 198.079 50.8854C197.964 50.4543 197.589 50.1242 197.165 49.9879C196.742 49.8516 196.278 49.8878 195.85 50.0065C195.064 50.2224 194.369 50.6971 193.756 51.22C192.887 51.9608 194.03 52.0109 194.616 52.4114H194.616Z",
  fill: "#FBB03B"
});
var _ref49 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M187.764 49.4114C188.746 49.3984 189.724 49.105 190.551 48.5747C190.666 48.5016 190.782 48.422 190.916 48.3961C191.171 48.348 191.418 48.5081 191.61 48.6821C192.148 49.1717 192.524 49.8473 193.152 50.2156C193.512 50.4267 193.979 50.5673 194.118 50.9607C194.226 51.2624 194.083 51.5974 193.888 51.851C193.693 52.1046 193.442 52.3165 193.28 52.5923C193.134 52.8404 193.068 53.1291 192.907 53.3679C192.674 53.7187 192.265 53.9195 191.852 54.0056C190.846 54.2156 189.864 53.8279 188.932 53.491C188.09 53.1865 186.802 53.1495 186.124 52.5748C185.522 52.0629 185.599 51.5132 185.703 50.807C185.891 49.5261 186.555 49.4271 187.764 49.4114L187.764 49.4114Z",
  fill: "#F9E8C0"
});
var _ref50 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M187.965 52.7942C188.609 52.9691 189.288 52.9774 189.937 53.1329C190.438 53.2523 190.927 53.4605 191.443 53.4614C191.958 53.4623 192.529 53.1709 192.621 52.6637C192.663 52.4324 192.601 52.1807 192.703 51.9688C192.756 51.8623 192.848 51.7726 192.868 51.655C192.91 51.4181 192.649 51.2469 192.42 51.1739C192.047 51.0563 191.651 51.0147 191.262 51.0545C190.889 51.0915 190.526 51.2016 190.152 51.2303C189.396 51.2886 188.84 50.9739 188.209 50.6158C187.761 50.3613 187.219 50.1244 186.747 50.489C185.65 51.3377 187.14 52.5703 187.965 52.7942L187.965 52.7942Z",
  fill: "#FBB03B"
});
var _ref51 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M182.967 50.348C183.417 50.4351 183.837 50.6472 184.291 50.7112C184.757 50.7769 185.229 50.6833 185.699 50.6769C186.171 50.6704 186.684 50.776 186.981 51.141C187.194 51.4022 187.261 51.7525 187.437 52.0397C187.759 52.564 188.44 52.8744 188.55 53.4813C188.672 54.1501 187.967 54.7199 187.291 54.7884C186.615 54.8579 185.951 54.6059 185.278 54.5058C184.512 54.391 183.444 54.869 182.764 54.6013C182.214 54.3845 181.988 53.7147 181.934 53.1848C181.827 52.1138 181.029 49.97 182.967 50.348L182.967 50.348Z",
  fill: "#F9E8C0"
});
var _ref52 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M187.703 53.4437C187.719 53.756 187.507 54.0657 187.21 54.1648C186.829 54.2909 186.428 54.0888 186.047 53.9609C185.417 53.7477 184.721 53.7375 184.086 53.9312C183.859 53.9998 183.635 54.0944 183.398 54.1009C183.073 54.1092 182.753 53.9387 182.561 53.6764C182.368 53.414 182.301 53.0692 182.36 52.7494C182.386 52.6011 182.44 52.4546 182.537 52.3397C182.7 52.1478 182.962 52.0672 183.213 52.0551C183.465 52.0421 183.715 52.0875 183.967 52.1014C184.453 52.1274 184.946 52.0301 185.387 51.8224C185.529 51.7548 185.678 51.6742 185.834 51.6973C185.967 51.7168 186.075 51.8094 186.177 51.8985C186.565 52.2396 187.703 52.8587 187.703 53.4437V53.4437Z",
  fill: "#FBB03B"
});
var _ref53 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M177.846 49.1279C178.396 48.9523 178.677 48.2768 179.234 48.1299C179.597 48.0338 179.979 48.1909 180.295 48.3933C180.61 48.5965 180.898 48.8497 181.25 48.98C181.725 49.1565 182.311 49.1094 182.669 49.467C182.958 49.7553 182.975 50.2709 182.705 50.5777C182.477 50.8364 182.1 50.9381 181.903 51.2209C181.691 51.5286 181.759 51.9491 181.619 52.2946C181.358 52.9434 180.503 53.0949 179.806 53.021C178.619 52.8953 176.643 52.2031 175.874 51.1922C175.552 50.7681 175.395 49.9299 175.68 49.4587C176.175 48.6381 177.135 49.3552 177.846 49.1279H177.846Z",
  fill: "#F9E8C0"
});
var _ref54 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M181.557 50.8643C181.466 51.1596 181.372 51.4632 181.173 51.7013C180.94 51.9838 180.581 52.1444 180.217 52.197C179.854 52.2487 179.482 52.2026 179.122 52.1305C178.464 51.9986 177.824 51.7808 177.223 51.4835C177.066 51.4051 176.904 51.3156 176.807 51.1697C176.634 50.9141 176.719 50.5467 176.936 50.3288C177.153 50.1101 177.471 50.0197 177.778 49.9975C178.086 49.9753 178.394 50.0132 178.702 50.0104C179 50.0077 179.296 49.967 179.582 49.8895C179.936 49.7935 180.3 49.6413 180.657 49.7271C181.331 49.8905 181.754 50.2199 181.557 50.8643Z",
  fill: "#FBB03B"
});
var _ref55 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M171.214 50.823C171.51 50.5798 171.928 50.5761 172.309 50.5327C172.941 50.4596 173.556 50.2441 174.095 49.9057C174.264 49.7993 174.435 49.6773 174.633 49.6514C174.881 49.6199 175.121 49.7448 175.334 49.877C176.007 50.2941 176.661 50.8397 177.453 50.8933C177.942 50.9266 178.491 50.7768 178.887 51.0662C179.172 51.2743 179.278 51.6737 179.188 52.014C179.1 52.3553 178.84 52.6345 178.532 52.8066C178.137 53.0267 177.581 53.1894 177.548 53.6397C177.528 53.894 177.705 54.1566 177.605 54.3906C177.567 54.4822 177.49 54.5524 177.409 54.6098C176.894 54.9704 176.198 54.877 175.58 54.7549C174.794 54.5996 174.001 54.4184 173.285 54.0577C172.622 53.7248 170.121 51.7172 171.214 50.823V50.823Z",
  fill: "#F9E8C0"
});
var _ref56 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M175.724 53.7271C175.248 53.7634 174.781 53.6089 174.329 53.4562C173.94 53.3259 173.55 53.1946 173.161 53.0633C172.779 52.9349 172.383 52.798 172.095 52.515C171.99 52.4117 171.9 52.2869 171.871 52.1417C171.8 51.7852 172.133 51.4556 172.487 51.3765C172.84 51.2964 173.206 51.3886 173.564 51.4379C174.094 51.5105 174.635 51.4891 175.156 51.3746C175.472 51.3057 175.793 51.2024 176.111 51.2555C176.306 51.2881 176.487 51.3774 176.656 51.4789C177.891 52.2134 176.843 53.6424 175.724 53.7271H175.724Z",
  fill: "#FBB03B"
});
var _ref57 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M163.616 51.7189C163.843 51.3239 164.299 51.1365 164.686 50.8972C165.091 50.6469 165.446 50.313 165.721 49.9245C166.012 49.5137 166.245 49.0139 166.702 48.8043C167.172 48.5892 167.729 48.7551 168.179 49.0083C168.628 49.2614 169.037 49.6009 169.527 49.7613C169.968 49.905 170.452 49.8957 170.881 50.0747C171.811 50.4623 172.166 51.8097 171.547 52.6054C171.003 53.3055 170.029 53.4464 169.18 53.7005C167.898 54.0835 166.497 54.8587 165.152 54.2457C164.337 53.873 163.059 52.6869 163.616 51.7189H163.616Z",
  fill: "#F9E8C0"
});
var _ref58 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M171.452 52.0473C171.342 52.2808 171.115 52.4394 170.882 52.5529C170.052 52.9562 169.067 52.9202 168.217 53.281C167.817 53.4509 167.457 53.7047 167.063 53.8901C166.669 54.0756 166.214 54.191 165.799 54.0608C165.506 53.9694 165.263 53.7665 165.03 53.568C164.83 53.3992 164.632 53.2303 164.433 53.0614C164.315 52.9618 164.188 52.8446 164.178 52.6905C164.164 52.4404 164.452 52.2946 164.69 52.2161C165.756 51.8665 166.821 51.5157 167.886 51.166C168.177 51.071 168.476 50.9741 168.782 50.9898C169.369 51.0211 169.925 51.4622 170.492 51.309C170.994 51.1733 171.812 51.2758 171.452 52.0473L171.452 52.0473Z",
  fill: "#FBB03B"
});
var _ref59 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M175.135 93.5688H170.065L163.298 53.5946H171.074L175.135 93.5688Z",
  fill: "#C1272D"
});
var _ref60 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M180.21 93.5688H175.139L171.077 53.5946H178.856L180.21 93.5688Z",
  fill: "white"
});
var _ref61 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.284 93.5688H180.212L178.858 53.5946H186.638L185.284 93.5688Z",
  fill: "#C1272D"
});
var _ref62 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M190.357 93.5688H185.286L186.64 53.5946H194.418L190.357 93.5688Z",
  fill: "white"
});
var _ref63 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M195.43 93.5688H190.361L194.421 53.5946H202.197L195.43 93.5688Z",
  fill: "#C1272D"
});
var _ref64 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.19,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.638 53.5955H178.858H171.078H163.298L164.322 59.6468H201.174L202.198 53.5955H194.418H186.638Z",
  fill: "#333333"
});
var _ref65 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M163.255 55.1971C162.371 55.1971 161.655 54.4807 161.655 53.597C161.655 52.7115 162.373 51.9936 163.259 51.9936H202.236C203.122 51.9936 203.84 52.7115 203.84 53.597C203.84 54.4807 203.123 55.1971 202.239 55.1971H163.255Z",
  fill: "white"
});
var _ref66 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M170.072 93.5694V96.757C170.072 97.102 175.746 97.3822 182.747 97.3822C189.747 97.3822 195.422 97.102 195.422 96.757V93.5694H170.072Z",
  fill: "#8E0617"
});
var _ref67 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.19,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.075 61.7941C193.596 68.916 192.501 78.7776 184.831 82.6123C179.809 84.7954 174.265 85.7569 168.719 85.6078L170.067 93.5641V96.756C170.067 97.1015 175.745 97.3821 182.749 97.3821C189.753 97.3821 195.431 97.1015 195.431 96.756V93.5641L201.031 60.5075C200.29 60.8475 199.615 61.254 199.075 61.7941V61.7941Z",
  fill: "#333333"
});
function SvgSeats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 171,
    viewBox: "0 0 370 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeats);
export default __webpack_public_path__ + "static/media/seats.c83b83c363e5d55f28fcbe593d98be4d.svg";
export { ForwardRef as ReactComponent };